import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { errore } from './comuni';

// Impostazioni → Rubrica banche e notai: la stessa di "Invia a banca / notaio". Per ogni banca il modello dei nomi
// dei file del fascicolo ({Cognome}_{Nome}_CI…), uno per tipo di documento; senza, Cognome_Nome_SIGLA.

const VUOTO = { ente: '', nome: '', email: '', telefono: '', tipo: 'banca' };

const Modello = ({ dest, tipi, info, onSalvato }) => {
  const [predefinito, setPredefinito] = useState(dest.modello_predefinito || '');
  const [nomi, setNomi] = useState(dest.modello_nomi || {});
  const salva = async () => {
    try {
      const r = await axios.put(`${API}/destinatari/${dest.id}`, { modello_predefinito: predefinito, modello_nomi: nomi });
      toast.success('Modello salvato');
      onSalvato(r.data);
    } catch (e) { toast.error(errore(e, 'Non salvato')); }
  };
  return (
    <div className="riquadro" style={{ flexBasis: '100%', marginTop: '.4rem' }} data-testid={`modello-${dest.id}`}>
      <p className="imp-nota">Segnaposto: {info.segnaposto.join(' ')} · se un tipo è vuoto vale il modello di base.</p>
      <div className="imp-campi" style={{ marginTop: '.6rem' }}>
        <label className="largo">Modello di base<input placeholder={info.predefinito} value={predefinito} onChange={(e) => setPredefinito(e.target.value)} /></label>
        {tipi.map((t) => (
          <label key={t.id} title={t.nome}>{t.nome}
            <input placeholder={`{Cognome}_{Nome}_${info.sigle[t.id] || t.id}`} value={nomi[t.id] || ''} onChange={(e) => setNomi({ ...nomi, [t.id]: e.target.value })} />
          </label>
        ))}
      </div>
      <div className="imp-azioni"><button type="button" className="btn sm p" onClick={salva}>Salva il modello</button></div>
    </div>
  );
};

const RubricaBanche = () => {
  const [elenco, setElenco] = useState(null);
  const [tipi, setTipi] = useState([]);
  const [info, setInfo] = useState(null);
  const [nuovo, setNuovo] = useState(VUOTO);
  const [aperto, setAperto] = useState(null);
  const carica = useCallback(() => axios.get(`${API}/destinatari`).then((r) => setElenco(r.data)).catch(() => setElenco([])), []);
  useEffect(() => {
    carica();
    axios.get(`${API}/documenti/catalogo`).then((r) => setTipi(r.data.tipi)).catch(() => {});
    axios.get(`${API}/fascicolo/segnaposto`).then((r) => setInfo(r.data)).catch(() => {});
  }, [carica]);
  const aggiungi = async () => {
    try { await axios.post(`${API}/destinatari`, nuovo); setNuovo(VUOTO); toast.success('Aggiunto alla rubrica'); carica(); } catch (e) { toast.error(errore(e, 'Non aggiunto')); }
  };
  const togli = async (d) => { try { await axios.delete(`${API}/destinatari/${d.id}`); carica(); } catch (e) { toast.error(errore(e, 'Non tolto')); } };
  const campo = (k, testo, props = {}) => <label>{testo}<input value={nuovo[k]} onChange={(e) => setNuovo({ ...nuovo, [k]: e.target.value })} {...props} /></label>;
  return (
    <div className="imp-griglia" data-testid="rubrica-banche">
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="piu" /></div><h2>Aggiungi banca o notaio</h2></div>
        <div className="imp-campi">
          {campo('ente', 'Ente', { placeholder: 'es. Intesa Sanpaolo' })}
          {campo('nome', 'Referente')}
          {campo('email', 'Email', { type: 'email' })}
          {campo('telefono', 'Telefono', { inputMode: 'tel' })}
          <label>Tipo
            <select value={nuovo.tipo} onChange={(e) => setNuovo({ ...nuovo, tipo: e.target.value })}>
              <option value="banca">Banca</option><option value="notaio">Notaio</option><option value="altro">Altro</option>
            </select>
          </label>
        </div>
        <div className="imp-azioni"><button type="button" className="btn sm p" disabled={!nuovo.ente.trim() || !nuovo.email.trim()} onClick={aggiungi}>Aggiungi</button></div>
      </section>
      <section className="card">
        <div className="ttl"><div className="i b"><Icona nome="edificio" /></div><h2>Rubrica {elenco ? <small>{elenco.length}</small> : null}</h2></div>
        {elenco && !elenco.length && <p className="vuoto">La rubrica è vuota: si riempie anche da "Invia a banca / notaio".</p>}
        <div className="imp-righe">
          {(elenco || []).map((d) => (
            <div key={d.id} data-testid={`destinatario-${d.id}`}>
              <b>{d.ente}</b>
              <span className={`tag ${d.tipo === 'notaio' ? 't-v' : d.tipo === 'banca' ? 't-b' : 't-o'}`}>{d.tipo}</span>
              <span className="descr">{[d.nome, d.email, d.telefono].filter(Boolean).join(' · ')}
                {Object.keys(d.modello_nomi || {}).length ? ` · modello per ${Object.keys(d.modello_nomi).length} tipi` : ''}</span>
              <div className="azioni">
                {info && <button type="button" className="btn xs" aria-expanded={aperto === d.id} onClick={() => setAperto(aperto === d.id ? null : d.id)}>Nomi dei file</button>}
                <button type="button" className="btn xs rosso-vuoto" onClick={() => togli(d)}>Togli</button>
              </div>
              {aperto === d.id && info && (
                <Modello dest={d} tipi={tipi} info={info} onSalvato={(nuovoD) => { setElenco(elenco.map((x) => (x.id === d.id ? nuovoD : x))); setAperto(null); }} />
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default RubricaBanche;
